import { render, staticRenderFns } from "./ModalEditContext.vue?vue&type=template&id=37570e63&scoped=true"
import script from "./ModalEditContext.vue?vue&type=script&lang=js"
export * from "./ModalEditContext.vue?vue&type=script&lang=js"
import style0 from "./ModalEditContext.vue?vue&type=style&index=0&id=37570e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37570e63",
  null
  
)

export default component.exports